import {Injectable} from 'ng-metadata/core';
import {getBackendSystem,getResultsBulkSize, getResultsPerPageForVEEnabled} from "../appConfig/appConfigForward";
import {SharedSessionStorage} from "../infra/sharedSessionStorage.service";
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import { Component, Inject, Input} from 'ng-metadata/core';
const get= require('lodash/get');


@Injectable()
export class ResultUtil {


	// private _updatedBulkSize: number;
	private _updatedBulkSize = getResultsBulkSize(this.$state.current.name);

    constructor(@Inject('$state') public $state: ng.ui.IStateService, 
                private sharedSessionStorage: SharedSessionStorage) {

    }

    private isAuthoritySearch(): boolean {
        return (this.$state.current.name === STATE_NAMES.AUTHORITY_SEARCH);
    }

    set updatedBulkSize(size) {
        this._updatedBulkSize = size;
    }

    get updatedBulkSize() {
        this.updateBulkSize();
        return parseInt(this._updatedBulkSize);
    }

    public isFrbr(item) {
        if (item.pnx.facets !== undefined) {
            if (!item || !item.pnx.facets.frbrtype) {
                return false;
            }
            let isFrbr = (item.pnx.facets.frbrtype[0] === '7' || item.pnx.facets.frbrtype[0] === '5');
            return (isFrbr);
        }
        return false;
    }

    public isMultipleVersions(item) {
        if (!item || this.isAuthoritySearch() || !item.pnx.display.version) {
            return false;
        }
        let frbrVersions = item.pnx.display.version[0];

        let isFrbrRecord = this.isFrbr(item);
        let isMultiVersions = frbrVersions ? (frbrVersions > 1) : true;

        return (isFrbrRecord && isMultiVersions);
    }


    public displayMultipleVersions(item, searchObject) {
        if (searchObject.facets) {
            let facetNames = searchObject.facets.map((facet, index, arr) => facet.name);
            return (this.isMultipleVersions(item) &&
                (facetNames.indexOf('frbrgroupid') === -1));
        }
        return this.isMultipleVersions(item);//in full view from deep link there are no facets but we
        // want the frbr indication
    }
    
    private updateBulkSize() {
        this._updatedBulkSize = getResultsBulkSize(this.$state.current.name);
        if (this.isResultsPerPageEnabled()){
            this._updatedBulkSize = this.sharedSessionStorage.getItem('resultsBulkSize') || this._updatedBulkSize;
        }
    }

    public isResultsPerPageEnabled() {
        if (getBackendSystem() === 'suprima'){
            return getResultsPerPageForVEEnabled();
        }
        else{
            return true;
        }
    }

    public getRangeData(){
        return this.updatedBulkSize;
    }

    public setRangeData(size){
        this.updatedBulkSize = size;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/resultUtil.service.ts